<template>
    <div v-wechat-title="title" class="background"
        :style="{ background: config.BoardConfigBakColor, '--rowcolor':config.BoardConfigTimeFontColor }">
        <div class="header" :style="{
                height: `${config.BoardConfigLogoHeaderHeight || '100'}px`,
                background: config.BoardConfigLogobgColor || ''
            }">
            <div class="logo">
                <!-- 红房子定制产科大屏 -->
                <img :src="Logo" />
                <span :style="{
                        color: config.BoardConfigTimeFontColor || '',
                        fontSize: `${config.BoardConfigTimeFontSize * xn}px`
                    }">{{ config.HospitalName }}</span>
            </div>
            <div class="time"
                :style="{ color: config.BoardConfigTimeFontColor || '', fontSize: `${config.BoardConfigTimeFontSize * xn}px` }">
                {{ nowtime }}
            </div>
        </div>
        <div :style="{ display: `flex`, 'flex-direction': `column`,height: contentHeight + 'px' }">
            <div class="flexitem" v-if="topRows.length > 0">
                <table class="table">
                    <tr v-for="(item, index) in topRows" :key="index" class="content" :style="{
                            color: FontColor((item.Enum_SurgeryStatus && item.Enum_SurgeryStatus.label) || ``),
                            backgroundColor: RowBackColor((item.Enum_SurgeryStatus && item.Enum_SurgeryStatus.label) || ``)
                        }">
                        <td v-for="(value, key) in item" :key="key" :style="getstyle(value)">
                            <div :style="getdivstyle(index, value, topRows[0][key])">
                                <marquee v-if="value.is_roll" behavior="scroll" direction="left" scrolldelay="100">{{
                                    value.label }}</marquee>
                                <span v-else>{{ value.label }}</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="flexitem" v-if="downRows.length > 0">
                <table class="table">
                    <tr v-for="(item, index) in downRows" :key="index" class="content" :style="{
                            color: FontColor((item.Enum_SurgeryStatus && item.Enum_SurgeryStatus.label) || ``),
                            backgroundColor: RowBackColor((item.Enum_SurgeryStatus && item.Enum_SurgeryStatus.label) || ``)
                        }">
                        <td v-for="(value, key) in item" :key="key" :style="getstyle(value)">
                            <div :style="getdivstyle(index, value, downRows[0][key])">
                                <marquee v-if="value.is_roll" behavior="scroll" direction="left" scrolldelay="100">{{
                                    value.label }}</marquee>
                                <span v-else>{{ value.label }}</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-if="is_show" class="text-show">
            <marquee behavior="scroll" direction="left" scrollamount="8" scrolldelay="100">{{ content.Content }}
            </marquee>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `CKBoard`,
    props: {
        topRows: { type: Array },
        downRows: { type: Array },
        columns: { type: Array },
        span: Number,
        title: String,
        BoardType: { type: Number, default: 2 }, // 0-家属屏  1-排程屏  2-产科家属屏
        BoardNo: { type: String, default: `0` } // 大屏编号
    },
    data() {
        return {
            time: this.$moment().format(`YYYY年MM月DD日 HH:mm`),
            pushRow1: 0,
            pushRow2: 0,
            nowtime: ``,
            config: {
                boardConfigBakColor: ``, // 大屏背景色配置
                boardConfigTimeFontColor: ``, // 右上角显示日期时间的字体颜色
                boardConfigLogoHeaderHeight: ``, // 电子屏头部Logo高度配置
                BoardConfigLogobgColor: ``, // 电子屏头部Header Logo的背景色
                boardConfigTimeFontSize: ``, // 电子屏头部公司和右上角日期时间字体大小配置
                HospitalName: ``, // 医院名称
                BoardConfigFontColor: ``, // 大屏状态控制字体颜色配置
                boardConfigRowBackColor: ``, // 大屏状态控制每行的背景色配置
                BoardConfigLogo: ``, // 大屏logo配置
                BoardConfigContent: ``, // 大屏显示内容配置
                BoardConfigFamilyScroll: ``, // 家属屏列表滚动频率，单位秒
                BoardSurgerytypeColor: ``, // 大屏手术类型背景色配置
                BoardConfigBorderColor: ``, // 电子屏边框颜色
                boardConfigFontSize: 30, // 电子屏设置 字体大小
                boardConfigHeaderHeight: ``, // 电子屏标题行行高
                boardLineHeight: ``, // 大屏表格数据行高
                CKBoardCount: 20 // 产科家属屏显示行数配置，超过时开始滚动模式

            },
            xn: 1,
            keys: [
                `BoardConfigBakColor`,
                `BoardConfigTimeFontColor`,
                `BoardConfigLogoHeaderHeight`, // 电子屏头部Logo高度配置
                `BoardConfigLogobgColor`,
                `BoardConfigTimeFontSize`, // 头部公司名称的字体大小
                `HospitalName`,
                `BoardConfigFontColor`,
                `BoardConfigRowBackColor`,
                `BoardConfigLogo`,
                `BoardConfigContent`,
                `BoardConfigFamilyScroll`,
                `BoardSurgerytypeColor`,
                `BoardConfigBorderColor`,
                `BoardConfigFontSize`,
                `BoardConfigHeaderHeight`,
                `BoardLineHeight`,
                `CKBoardCount`
            ],
            content: {},
            is_show: false,
            BoardSurgerytypeColorObj: null
        }
    },
    created() {
        this.init().then(() => {
            this.isShow().then(data => {
                this.is_show = data
            })
        })

        if (document.documentElement.clientWidth > 1024) {
            this.xn = 2
        } else {
            this.xn = 1
        }
    },
    mounted() {
    },
    computed: {
        ...mapGetters([`screenHeight`, `active_ward`, `ward_auth`, `localip/ipAddress`]),
        contentHeight() {
            return this.screenHeight - (this.config.BoardConfigLogoHeaderHeight || `100`)
        },
        FontColor() {
            if (this.config.BoardConfigFontColor == ``) return () => { }
            let fontConfigs = JSON.parse(this.config.BoardConfigFontColor)
            return item => {
                let color = ``
                for (let config of fontConfigs) {
                    if (config.value == item) {
                        color = config.color
                    }
                }
                return color
            }
        },
        RowBackColor() {
            return item => {
                // 没有设置默认=整个电子屏的背景色
                let rowBackColor = this.config.BoardConfigRowBackColor || ``
                if (item == `` || rowBackColor == ``) return ``
                let fontConfigs = JSON.parse(this.config.BoardConfigRowBackColor)
                let color = ``
                for (let config of fontConfigs) {
                    if (config.value == item) {
                        color = config.color
                    }
                }
                return color
            }
        },
        Logo() {
            return `../../../static/img/${this.config.BoardConfigLogo || `logo_white.png`}`
        }
    },
    methods: {
        startScroll1() {
            let that = this
            let BoardConfigScroll = parseInt(this.config.BoardConfigFamilyScroll || `0`)
            let BoardCount = parseInt(this.config.CKBoardCount || `10`)
            if (BoardConfigScroll > 0 && BoardCount < (this.topRows.length - 1)) {
                if (this.loadtopRows_timer) {
                    clearInterval(this.loadtopRows_timer)
                }
                this.loadtopRows_timer = setInterval(() => {
                    const allcount1 = this.topRows.length - 1
                    console.log(`pushRow1`, that.pushRow1)
                    if (that.pushRow1 < allcount1) {
                        that.pushRow1++
                        const removeItems1 = this.topRows.splice(1, 1) // 移除元素
                        this.topRows.push(...removeItems1) // 将它们添加到数组末尾
                    } else {
                        this.$emit(`loadTopList`)
                    }
                }, BoardConfigScroll * 1000)
            }
        },
        startScroll2() {
            let that = this
            let BoardConfigScroll = parseInt(this.config.BoardConfigFamilyScroll || `0`)
            let BoardCount = parseInt(this.config.CKBoardCount || `10`)
            if (BoardConfigScroll > 0 && BoardCount < (this.downRows.length - 1)) {
                if (this.loaddownRows_timer) {
                    clearInterval(this.loaddownRows_timer)
                }
                this.loaddownRows_timer = setInterval(() => {
                    const allcount2 = this.downRows.length - 1
                    console.log(`pushRow2`, that.pushRow2)
                    if (that.pushRow2 < allcount2) {
                        that.pushRow2++
                        const removeItems2 = this.downRows.splice(1, 1) // 移除元素
                        this.downRows.push(...removeItems2) // 将它们添加到数组末尾
                    } else {
                        this.$emit(`loadDownList`)
                    }
                }, BoardConfigScroll * 1000)
            }
        },
        init() {
            let BoardSurgerytypeColor = this.config.BoardSurgerytypeColor
            console.log(`BoardSurgerytypeColor`, BoardSurgerytypeColor)
            if (BoardSurgerytypeColor != ``) {
                this.BoardSurgerytypeColorObj = JSON.parse(BoardSurgerytypeColor)
                console.log(`BoardSurgerytypeColor2`, this.BoardSurgerytypeColorObj)
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                let obj = {}
                req.then(data => {
                    let boards = _.filter(data, d => {
                        return this.keys.indexOf(d.key) > -1
                    })
                    for (let board of boards) {
                        obj[board.key] = board.value
                    }
                    this.config = obj
                    this.$emit(`init`, this.config)
                    resolve()
                })
            })
        },
        getstyle(value) {
            if (value.header_style && value.header_style.length > 0 && value.header_style[0] != null) {
                var style = value.header_style[0]
                style.width = `${(value.span / 24) * 100}%`
                style.display = `${value.span == 0 ? `none` : `table-cell`}`
                return value.header_style[0]
            } else {
                return {
                    width: `${(value.span / 24) * 100}%`,
                    border: `1.5px solid ${this.config.BoardConfigBorderColor || `red`}`,
                    display: `${value.span == 0 ? `none` : `table-cell`}`,
                    fontSize: `${this.config.BoardConfigFontSize * this.xn}px`,
                    backgroundColor: value.display_back_color || ``, // 设置了列头背景色就显示背景色，没有设置就显示行的背景色
                    color: value.color || ``
                }
            }
        },
        getdivstyle(index, value, all) {
            let that = this
            let style = {}
            if (index !== 0 && all.column_style && all.column_style.length > 0 && all.column_style[0] != null) {
                style = all.column_style[0]
            } else {
                style = {
                    'overflow': `hidden`,
                    'text-overflow': `ellipsis`,
                    'display': `-webkit-flex`,
                    'align-items': `center`,
                    'justify-content': `center`
                }
            }
            style.height = `${index === 0 ? that.config.BoardConfigHeaderHeight : that.config.BoardLineHeight}px`

            return style
        },
        isShow() {
            return new Promise(resolve => {
                if (!this.config.BoardConfigContent) return
                let isShow = false
                let now = new Date()
                let day = now.getDay()
                let boardConfigContent = JSON.parse(this.config.BoardConfigContent)
                this.content = boardConfigContent
                let startTime = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${boardConfigContent.startTime}`)
                let endTime = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${boardConfigContent.endTime}`)
                let weeks = boardConfigContent.week.split(`|`)
                if (boardConfigContent.BoardNo == this.BoardNo && weeks.indexOf(day.toString()) != -1 && now >= startTime && now <= endTime) {
                    isShow = true
                }
                resolve(isShow)
            })
        }
    },
    destroyed() {
        if (this.loadtopRows_timer) {
            clearInterval(this.loadtopRows_timer)
        }
        if (this.loaddownRows_timer) {
            clearInterval(this.loaddownRows_timer)
        }
    },
    watch: {
        is_show(newValue) {
            console.log(newValue)
            if (this.is_show == !newValue) {
                this.is_show = newValue
            }
        },
        topRows(newValue) {
            console.log(`topRows`, newValue)
            if (this.pushRow1 === 0) {
                this.startScroll1()
            }
        },
        downRows(newValue) {
            console.log(`downRows`, newValue)
            if (this.pushRow2 === 0) {
                this.startScroll2()
            }
        }
    }
}
</script>

<style scoped>
    .background {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #1f2d3d;
    }

    .header {
        position: relative;
        top: 0;
        border-left: 1.5px solid #ffffff;
        border-right: 1.5px solid #ffffff;
        border-bottom: 1.5px solid #ffffff;
        overflow: hidden;
    }

    .logo {
        float: left;
        font-size: 30px;
        color: #ffffff;
        width: 65%;
        height: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .logo span {
        float: left;
        width: 65%;
        max-width: 65%;
        text-align: left;
        box-sizing: border-box;
        padding: 0 10px;
        max-height: 95%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
        justify-content: left;
        height: 95%;
        line-height: 95%;
    }

    .logo img {
        float: left;
        width: auto;
        height: auto;
        max-width: 90%;
        max-height: 95%;
        box-sizing: border-box;
        padding: 5px;
    }

    .time {
        float: right;
        color: #ffffff;
        overflow: hidden;
        white-space: nowrap;
        height: 95%;
        line-height: 95%;
        width: 35%;
        text-align: right;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
    }

    .footer {
        position: relative;
        bottom: 0;
        background-color: var(--primary-color, #009688);
        height: 60px;
    }

    .content {
        color: #ffffff;
        border-bottom: 5px solid #ffffff;
    }

    .ellipsis1 {
        display: inline-block;
        overflow: hidden;
        width: 100%;
    }

    .text-show {
        color: var(--rowcolor);
        font-size: 50px;
        margin: 0 auto;
        height: 60px;
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100%;
    }

    .table {
        width: 100%;
        table-layout: fixed;
        border-spacing: 0px;
    }

    .table td {
        word-wrap: break-word;
    }
    .flexitem {
        flex: 1; /* 每个content元素平分容器空间 */
        overflow-y: auto; /* 允许垂直滚动 */
        max-height: 50vh; /* 内容最大高度为视口高度的50% */
    }
</style>



// WEBPACK FOOTER //
// src/components/Board/CKBoard.vue